import { ClientOrCache } from '@sketch/graphql-cache'
import {
  readShareListItemFromCache,
  removeFromStorageItemsList,
  updateProjectListCounts,
  updateProjectListPreviewsAndCounts,
} from '@sketch/modules-common'

export interface HandleShareDeletedPermanentlyProps {
  cache: ClientOrCache
  identifier: string
}

export const handleShareDeletedPermanently = (
  props: HandleShareDeletedPermanentlyProps
) => {
  const { cache, identifier } = props

  // See if this share has been cached before
  const previousShare = readShareListItemFromCache({
    cache,
    id: identifier,
  })

  removeFromStorageItemsList({
    cache,
    target: { __typename: 'Share', identifier },
  })

  if (previousShare?.project) {
    updateProjectListPreviewsAndCounts(
      cache,
      previousShare.project.identifier,
      project => {
        project.previews = project.previews.filter(
          ({ shareIdentifier }) => shareIdentifier !== identifier
        )
        project.sharesCount--
      }
    ) ||
      // If we can't find fragment we should try to at least find the counts
      updateProjectListCounts(
        cache,
        previousShare.project.identifier,
        project => {
          project.sharesCount--
        }
      )
  }
}
